import { CreativeManagementProperties } from 'api-contracts';
import ITableOptions from '@/components/domain/creatives/ITableOptions';

export const sortOptions: ITableOptions<CreativeManagementProperties> = {
    itemsPerPage: 10,
    page: 1,
    sortBy: ['updatedAt'],
    sortDesc: [true],
};
